import { Flex, Text, TextField } from '@scale/scaleui-radix';

interface RowsToGenerateInputProps {
  value: number;
  onChange: (value: number) => void;
}

export default function RowsToGenerateInput({ value, onChange }: RowsToGenerateInputProps) {
  return (
    <Flex direction="column" gap="2">
      <Text size="2" weight="medium">
        Number of Tasks to Generate Per Locale
      </Text>
      <TextField.Root
        type="number"
        value={value}
        onChange={e => onChange(parseInt(e.target.value, 10) || 1)}
        min={1}
      />
    </Flex>
  );
}
